import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export function IconButton({
  active,
  children,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { active?: boolean }) {
  return (
    <button
      type="button"
      className={cx(
        'group relative flex h-8 w-8 items-center justify-center rounded-md transition',
        active
          ? 'bg-[color:var(--v2-accent)] text-[color:var(--v2-accent-ink)] shadow-[0_4px_10px_-4px_rgba(20,25,42,0.5)]'
          : 'text-[color:var(--v2-ink-soft)] hover:bg-white/70 hover:text-[color:var(--v2-ink)]',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
